import {appSecret, encrypt} from "@/views/upload/utils/utils";
import {Hmacstr} from "@/views/upload/utils/Sign";
import {get} from "@/axios/requestUtil";

/**
 * 分片上传提交
 * @param token
 * @param uploadFileId
 * @returns {Promise<unknown>}
 */
export const commitMultiUploadFile = (token, uploadFileId) => {
    console.log("正在上传提交。。。")
    const url = "/person/commitMultiUploadFile"
    const dateStr = new Date().toUTCString()
    let params = "uploadFileId=" + uploadFileId
    let encryptParam = encrypt(params, appSecret.substring(0, 16))
    let paramResult = "token=" + token + "&Operate=GET" + "&RequestURI=" + url + "&Date=" + dateStr + "&params=" + encryptParam
    const signature = Hmacstr(paramResult, appSecret).toString().toUpperCase();
    const header = {
        'token': token,
        'Signature': signature,
        'X-Request-Date': dateStr,
        'IsJson': '1',
    }

    return new Promise((resolve, reject) => {
        get('/fileupload/person/commitMultiUploadFile?params=' + encryptParam, null, header).then(resp => {
            resolve(resp)
        }).catch(onerror => {
            resolve(onerror.data)
        })
    })
}